import React, { useEffect, useId, useRef, useState } from "react";
import "./TextBox.css"; // Custom CSS for styling
import { FontSizeWidth } from "../constant";
import { useSelector } from "react-redux";
import { selectWidth } from "../Redux/profile";

const OutlinedTextBox = ({
  label = "",
  id = "",
  bgColor = "white",
  fontWeight = "normal",
  align = "left",
  onKeyDown = () => {},
  width = "100%",
  value = "",
  search,
  onChange = () => {},
  type = "text",
  readOnly = false,
  refrance,
  onFocus = () => {},
  onClick = () => {},
  autoFocus = false,
  color = "gray",
  fontSize,
  titleBold,
  onBlur,
  option,
  textArea,
  borderColor,
}) => {
  const windowWidth = useSelector(selectWidth);
  const generatedId = useId();
  const inputId = id || `outlined-input-${generatedId.replace(/:/g, "")}`;
  return (
    <div className="outlined-textbox-container" style={{ width }}>
      <div
        style={
          borderColor
            ? {
                border: `1px solid ${borderColor}`,
                borderRadius: "4px",
              }
            : {}
        }
        className={!borderColor ? "outlined-textbox-wrapper" : ""}
      >
        {label && (
          <label
            htmlFor={inputId}
            className="outlined-textbox-label"
            style={{
              fontSize: fontSize ? fontSize : FontSizeWidth(windowWidth),
              fontWeight: fontWeight ? fontWeight : "normal",
              color: color ? color : "gray",
            }}
          >
            {label}
          </label>
        )}
        {!textArea && (
          <div className="outlined-input-wrapper">
            {!option && (
              <input
                id={inputId}
                type={type}
                value={value}
                onChange={onChange}
                readOnly={readOnly ? readOnly : false}
                ref={refrance}
                onFocus={onFocus}
                onKeyDown={onKeyDown ? onKeyDown : () => {}}
                onClick={onClick}
                autoFocus={autoFocus ? autoFocus : false}
                onBlur={(e) => {
                  if (onBlur) {
                    onBlur(e);
                  }
                }}
                style={{
                  textAlign: align ? align : "left",
                  outline: "none",
                  fontSize: FontSizeWidth(windowWidth),
                  backgroundColor: bgColor ? bgColor : "white",
                }}
                className="outlined-textbox-input "
              />
            )}
            {option && (
              <CustomSelect
                value={value}
                options={option}
                autoFocus={autoFocus ? autoFocus : false}
                onChange={onChange}
              />
            )}

            {search && (
              <button
                type="button"
                className="outlined-textbox-search-btn"
                onClick={search}
                aria-label={`${label || "Field"} lookup`}
                title={`${label || "Field"} lookup`}
              >
                <i className="bi bi-search"></i>
              </button>
            )}
          </div>
        )}

        {textArea && (
          <textarea
            ref={refrance}
            className="border outline-none p-2"
            value={value}
            onKeyDown={onKeyDown ? onKeyDown : () => {}}
            onChange={onChange}
          />
        )}
      </div>
    </div>
  );
};

export default OutlinedTextBox;
const CustomSelect = ({ options = [], value, onChange, autoFocus = false }) => {
  const [open, setOpen] = useState(false);
  const [focusedIndex, setFocusedIndex] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const containerRef = useRef(null);
  const scrollRef = useRef(null);
  const searchTimeout = useRef(null);

  const handleSelect = (val) => {
    onChange({ target: { value: val } });
    setOpen(false);
  };

  const handleKeyDown = (e) => {
    if (!open && (e.key === "Enter" || e.key === "ArrowDown")) {
      setOpen(true);
    } else if (open) {
      if (e.key === "ArrowDown") {
        setFocusedIndex((prev) => {
          const newIndex = (prev + 1) % options.length;
          scrollToOption(newIndex);
          return newIndex;
        });
      } else if (e.key === "ArrowUp") {
        setFocusedIndex((prev) => {
          const newIndex = (prev - 1 + options.length) % options.length;
          scrollToOption(newIndex);
          return newIndex;
        });
      } else if (e.key === "Enter") {
        handleSelect(options[focusedIndex].value);
      } else if (e.key === "Escape") {
        setOpen(false);
      } else if (e.key.length === 1) {
        // Typing letters: accumulate & search
        const newTerm = searchTerm + e.key.toLowerCase();
        setSearchTerm(newTerm);

        const foundIndex = options.findIndex((o) =>
          o.value.toLowerCase().startsWith(newTerm)
        );
        if (foundIndex >= 0) {
          setFocusedIndex(foundIndex);
        }

        clearTimeout(searchTimeout.current);
        searchTimeout.current = setTimeout(() => {
          setSearchTerm("");
        }, 1000); // reset after 1s
      }
    }
  };

  const scrollToOption = (index) => {
    const optionElement = scrollRef.current.children[index];
    if (optionElement) {
      optionElement.scrollIntoView({
        behavior: "smooth",
        block: "nearest", // makes it scroll the nearest option into view
      });
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div
      ref={containerRef}
      tabIndex={0}
      onKeyDown={handleKeyDown}
      className="relative w-full p-1 bg-white cursor-pointer focus:outline-none  rounded"
    >
      <input
        value={value}
        autoFocus={autoFocus}
        readOnly
        onClick={() => setOpen((prev) => !prev)}
        className="outline-none w-full bg-transparent"
      />

      {open && (
        <div
          ref={scrollRef}
          className="absolute z-10 w-full bg-white border border-gray-300 mt-1 rounded shadow-md max-h-48 overflow-y-auto"
        >
          {options.map((o, index) => (
            <div
              key={index}
              onClick={() => handleSelect(o.value)}
              onMouseEnter={() => setFocusedIndex(index)}
              className={`p-2 cursor-pointer transition-colors duration-100 ${
                index === focusedIndex
                  ? "bg-orange text-black"
                  : o.value === value
                  ? "bg-gray-100 text-orange"
                  : "text-gray-800"
              }`}
            >
              {o.value}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
